export {default as NotFoundPage} from './NotFoundPage';



// WEBPACK FOOTER //
// ./src/pages/NotFoundPage/index.ts